<template>
  <div class="box">
    <ShowQy v-if="selectid==0" :showInfo="showInfo"></ShowQy>
    <ShowGr v-if="selectid==1" :showInfo="showInfo"></ShowGr>
    <show-rz v-if="selectid==2" :showInfo="showInfo"></show-rz>
  </div>
  
</template>
<script>
import ShowQy from './show/ShowQyM.vue';
import ShowGr from './show/ShowGrM.vue';

import { certificateGR, certificateQY ,certificateRZ } from '@/request/index';
import ShowRz from './show/ShowRzM.vue';
export default {
  metaInfo: {
    title: '中国智慧工程研究会职业发展规划工作委员会',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0,minimal-ui:ios`
      }
    ]
  },
  name: "show",
  components: {
    ShowQy,//企业证书
    ShowGr,
    ShowRz//人员证书
  },
  data() {
    return {
      column: [{
        id: 0,
        name: "企业证书查询",
        func: certificateQY
      }, {
        id: 1,
        name: "个人证书查询",
        func: certificateGR
      }, {
        id: 2,
        name: "认证服务查询",
        func: certificateRZ
      }],
      showInfo: null,
      selectid:""
    }
  },
  created() {
    this.query();
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
     */
    async query() {
      let { cname, ccode, bzcode, selectid, certname } = this.$route.query;
      selectid = parseInt(selectid)
      // console.log( this.column[selectid])
      try{
        let result = await this.column[selectid].func(bzcode, cname, ccode);
        if (result.success) {
          let arrs = result.data.filter((item) => item.certname == certname);
          this.showInfo = this.dealJszcdw(this.dealNianjian(arrs[0]));
          this.selectid = selectid;
        } else {
          this.showInfo = null; 
          this.$router.push('/inquery');
        }
      }catch(err){
        this.showInfo = null; 
          this.$router.push('/inquery'); 
      }
      
    },
    /**
     * nianjian转Array
     * "第一年,第二年,第三年"
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealNianjian(obj) {
      // let nianjian = obj.nianjian||'';
      // let arr = nianjian && nianjian.split(",");
      // //最多三个
      // let nianjians = ["", "", ""].map((item, index) => {
      //   if (index < arr.length) {
      //     return arr[index];
      //   } else {
      //     return item;
      //   }
      // })
      // obj.nianjian = nianjians;
      return obj;
    },
    /**
     * 技术支持单位
     * 名称##网址||名称##网址
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealJszcdw(obj) {
      // let jszcdw = obj.jszcdw||'';
      // let jszcdws = [];
      // let temps = [];
      // let items = [];
      // if (jszcdw.indexOf('||') > -1) {//多条
      //   temps = jszcdw.split("||");
      //   jszcdws = temps.map(item => {
      //     if (item.indexOf('##') > -1) {
      //       items = jszcdw.split("##");
      //       return { name: items[0], path: items[1] };
      //     }
      //     return { name: '', path: ''};
      //   });
      // } else {//仅一条
      //   if (jszcdw.indexOf('##') > -1) {
      //     items = jszcdw.split("##");
      //     jszcdws.push({ name: items[0], path: items[1] });
      //   }
      // }
      // for (let i = 0, len = 4 - jszcdws.length; i < len; i++){//补满4条数据
      //   jszcdws.push({ name: '', path: '' });
      // }
      // obj.jszcdw = jszcdws;
      return obj;
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
  width: 100%;
  background-color: #F8FFFB;
}
</style>